import { FC } from 'react';

import { EMAIL, NEW_SESSION } from 'util/const';

import Button from 'components/atoms/Button';

import styles from './PaymentStep.module.scss';

const PaymentStep: FC = () => {
  return (
    <>
      <div>
        <h3 className={styles.title}>資料確認</h3>
        <p>
          您已成功繳交第 {NEW_SESSION} 屆資訊種子培訓計畫的書審資料，提醒您繳交報名費 100 元後，才算完成報名程序，請於
          2026/07/13 23:59 前至 ACCUPASS 完成繳費。
          <br />
          （＊報名成功信將於繳交報名費後寄出。）
        </p>
      </div>
      <div className={styles.divisionLine} />
      <div>
        <h3 className={styles.title}>完成繳費</h3>
        <p>
          完成資料填寫後，請於 2026/07/13 23:59 前至 ACCUPASS 繳交 100 元報名費。繳交完畢後預計於三個工作天內收到
          ACCUPASS 回覆。
          <br />
          若三天內未收到回覆（請先檢查垃圾信件）請來信至 {EMAIL} 詢問。
        </p>
      </div>
      <Button>
        <a href="https://www.accupass.com/event/2605211727251184723621" target="_blank" rel="noreferrer">
          前往繳費
        </a>
      </Button>
    </>
  );
};

export default PaymentStep;
